export default __webpack_public_path__ + "static/media/book.82ada76a.jpeg";